export const COLS = 40;
export const ROWS = 32;
export const PIXEL_COUNT = COLS * ROWS; // 1280
export const OFF: string = '#000000';

export type HexColor = string;     // "#rrggbb"
export type Frame = HexColor[];    // length PIXEL_COUNT, row-major (index = y*COLS + x)

export interface AnimationFrame {
  ms: number;          // duration this frame shows
  pixels: Frame;
}

export interface LivePayload {
  mode: 'frame' | 'animation';
  brightness: number;  // 0-255
  updatedAt: number;
  frame?: Frame;
  enc?: 'deflate';
  data?: string;
  animation?: { loop: boolean; frames?: AnimationFrame[]; enc?: 'deflate'; count?: number; data?: string };
}

export interface LedDesign {
  key?: string;
  name: string;
  w: number;
  h: number;
  type: 'frame' | 'animation';
  frame?: Frame;
  animation?: { loop: boolean; frames: AnimationFrame[] };
  thumbnail: string;   // data URL
  createdAt: number;
}

export function emptyFrame(): Frame {
  return new Array(PIXEL_COUNT).fill(OFF);
}

export function idx(x: number, y: number): number {
  return y * COLS + x;
}
